import React, {useState} from 'react'

const useDialog = () => {
  const [show, setShow] = useState(false)

  const handleModalOpen = () => {
    setShow(true)
  }

  const handleModalClose = () => {
    setShow(false)
  }

  return {
    show,
    handleModalOpen,
    handleModalClose
  }
}

export default useDialog
